import React, { useCallback } from 'react'
import { Button } from 'antd'
import { Calculator, Percent } from 'lucide-react'
import { t } from 'i18next'
import { useSelector } from 'react-redux'
import { EnhancedStatementRow } from '../../../../utils/dataEnhancement'
import { notLocked } from '../../../../../../pages/settings/company/budgeting/budgetingScenarios/utils'
import { filtersSelector } from '../../../../../../redux/context/filters/selectors'
import { useModalActions } from '../../ModalContext'

/**
 * Get budget method icon based on budgeting method
 */
const getBudgetMethodIcon = (budgetingMethod?: string) => {
  switch (budgetingMethod) {
    case 'absolute':
      return t('global:currency-symbol')
    case 'reference':
      return <Percent style={{ color: '#F59E0B' }} size={14} />
    case 'driver':
      return <Calculator style={{ color: '#0AB273' }} size={14} />
    default:
      return t('global:currency-symbol')
  }
}

interface BudgetMethodButtonProps {
  data: EnhancedStatementRow | undefined
  style?: React.CSSProperties
}

export const BudgetMethodButton: React.FC<BudgetMethodButtonProps> = ({ data, style }) => {
  const { budgetingScenario } = useSelector(filtersSelector)
  const { openBudgetMethodModal } = useModalActions()
  const isDisabled = !notLocked(budgetingScenario)

  const handleBudgetButtonClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation()
      if (data) {
        openBudgetMethodModal({ data })
      }
    },
    [data, openBudgetMethodModal]
  )

  return (
    <Button
      type="link"
      size="small"
      icon={getBudgetMethodIcon(data?.budgetingMethod?.method)}
      onClick={handleBudgetButtonClick}
      style={style}
      disabled={isDisabled}
    />
  )
}
